import { fetchWrapper } from "./fetchWrapper";

export const createSCAPIFetch = (commerceAPIConfig, endpointsPath, slotParams) =>
  async (endpoint, method, args, body, isDeliveryPassTempBasket) => {

    const host = commerceAPIConfig.apiHost
      ? `https://${commerceAPIConfig.apiHost}`
      : commerceAPIConfig.commerceAPI.proxyPath;

    const { siteId } = commerceAPIConfig.commerceAPI.parameters;
    const { organizationId } = commerceAPIConfig.commerceAPI.parameters;



    let queryString = `siteId=${siteId}&${slotParams}`;
    const endpointParts = endpoint.split('?');
    let apiUrl;
    if (isDeliveryPassTempBasket) {
      const tempQuery = `temporary=true`;
      queryString = `${queryString}&${tempQuery}`;
      if (endpointParts[1]) {
        queryString = `${queryString}&${endpointParts[1]}`;
      }
      apiUrl = `${host}/${endpointsPath}/v2/organizations/${organizationId}/${endpointParts[0]}?${queryString}`;
    } else {
      if (endpointParts[1]) {
        queryString = `${queryString}&${endpointParts[1]}`;
      }
      apiUrl = `${host}/${endpointsPath}/v1/organizations/${organizationId}/${endpointParts[0]}?${queryString}`;
    }

    const options = {
      method,
      headers: {
        ...args[0].headers,
        'Content-Type': 'application/json',
      },
      ...(body && {
        body: JSON.stringify(body),
      }),
    };

    let response = await fetchWrapper(
      apiUrl,
      options
    );

    const htmlResponse = await response
    return htmlResponse;
  };